module.exports = __webpack_public_path__ + "static/media/logo-greyscale.b8bb732a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-greyscale.svg
// module id = 120
// module chunks = 0